import { FormattedMessage } from 'react-intl';

import { useSearchParameters } from '@xing-com/crate-hooks-use-search-parameters';
import { SEARCH_STATE_PARAMS } from '@xing-com/crate-jobs-constants';
import { useFilter } from '@xing-com/crate-jobs-hooks';
import { Tag } from '@xing-com/tag';
import { BodyCopy } from '@xing-com/typography';

import { SINCE_PERIOD_OPTIONS } from '../../../helpers';
import * as S from '../shared.styles';

export const TimeFrameFilter: React.FC = () => {
  const { value: sincePeriod } = useFilter(SEARCH_STATE_PARAMS.sincePeriod);
  const { setSearchParameters } = useSearchParameters();

  const handleOnClick = (option: string) => (): void => {
    setSearchParameters(
      {
        [SEARCH_STATE_PARAMS.sincePeriod]: option,
        // When selecting any time frame option, we need to clear the since parameter
        [SEARCH_STATE_PARAMS.since]: '',
      },
      { removeEmpty: true }
    );
  };

  return (
    <div role="group" aria-labelledby="time-frame-filter-title">
      <BodyCopy
        fontWeight="bold"
        data-testid="all-filters-filter"
        id="time-frame-filter-title"
      >
        <FormattedMessage id="JOBS_SEARCH_FILTER_TIME_FRAME" />
      </BodyCopy>
      <S.TagsContainer>
        {Object.entries(SINCE_PERIOD_OPTIONS).map(([option, text]) => (
          <Tag
            key={option}
            selected={option === sincePeriod}
            onClick={handleOnClick(option)}
          >
            {text}
          </Tag>
        ))}
      </S.TagsContainer>
    </div>
  );
};
